import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import ReportService from "../../apiServices/masters/reportService";
import { setReport, setReports, setReportsDaily, setReportsMonthly, setReportsYearly } from "../../store/slices/master/reportSlice";
import { ReportFrequency } from "../../models/dashboard/adminDashboard";

export function getReport(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await ReportService.getReport(id);
    if (response?.success === true) {
      dispatch(setReport(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getReports(configUserRole?: number, pageBlockId?: number, noOfItems?: number, reportFrequency?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await ReportService.getReports(configUserRole, pageBlockId, noOfItems, reportFrequency);
    if (response?.success === true) {
      if (reportFrequency === ReportFrequency.Daily) {
        dispatch(setReportsDaily(response.data));
      }
      else if (reportFrequency === ReportFrequency.Monthly) {
        dispatch(setReportsMonthly(response.data))
      }
      else if (reportFrequency === ReportFrequency.Yearly) {
        dispatch(setReportsYearly(response.data))
      }
      else {
        dispatch(setReports(response.data));
      }
    } else {
      console.log("error");
    }
  };
}


export function createReport(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await ReportService.createReport(data);
    const name = data.get("name")
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      }
      else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateReport(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await ReportService.updateReport(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateReportPriority(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await ReportService.updateReportPriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}

export function deleteReport(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await ReportService.deleteReport(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}
